import React from "react";
import {
  StackProps,
  Text,
  VStack,
  Link,
  CardBody,
  Card,
} from "@chakra-ui/react";

import { BuildDescription } from "./BuildDescription";
import { CCV } from "./CCV";

type FooterProps = StackProps;

export function Footer({ ...delegated }: FooterProps) {
  return (
    <Card
      as="footer"
      marginTop="16px"
      borderRadius="0"
      width="100%"
      {...delegated}
      fontSize="xs"
    >
      <CardBody as={VStack}>
        <Text>
          Made and Maintained by the
          <Link
            marginLeft="0.25rem"
            marginRight="0.25rem"
            href="https://ccv.brown.edu/"
          >
            Center for Computation and Visualization
          </Link>
          @ Brown University | 180 George St, Providence RI 02906
        </Text>
        <Text>
          For questions, concerns, or bugs, email
          <Link marginLeft="0.25rem" href="mailto:support@ccv.brown.edu">
            support@ccv.brown.edu
          </Link>
          .
        </Text>
        <BuildDescription />
        <CCV width="100px" />
      </CardBody>
    </Card>
  );
}
